import {EventBus} from '@qingjin/jsuper';
const eventBus = new EventBus()
export default eventBus